module.exports = __webpack_public_path__ + "img/pic_logo.58f2ae37.png";